import React, { CSSProperties, memo } from 'react';
import classNames from 'classnames';
import cls from './Skeleton.module.css';

interface SkeletonProps {
    classes?: string;
    height?: string | number;
    width?: string | number;
    border?: string;
}

export const Skeleton = memo((props: SkeletonProps) => {
    const { classes, height, width, border } = props;

    const styles: CSSProperties = {
        width: width ? width : '100%',
        height: height ? height : '100%',
        borderRadius: border,
    };

    return <div className={classNames(cls.Skeleton, {}, [classes])} style={styles} />;
});
